import { render } from "./KlienDetail.vue?vue&type=template&id=192eaed5"
import script from "./KlienDetail.vue?vue&type=script&lang=js"
export * from "./KlienDetail.vue?vue&type=script&lang=js"

import "./KlienDetail.vue?vue&type=style&index=0&id=192eaed5&lang=css"
script.render = render

export default script